/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';

import { ContactCustomerType } from '../contacts';
import { LeadBoardListItemDto, LeadBoardListItemParams } from './lead-board.dto';
import { SalesFolderStatus } from './sales-folder.dto';

export const LeadBoardItemMapper = entity<LeadBoardListItemDto>({
  status: enumeration(SalesFolderStatus),
  addedDate: date(DateFormat.DateTime),
  followUpDate: date(DateFormat.DateTime),
  customerType: enumeration(ContactCustomerType),
});

export const LeadBoardParamsMapper = entity<LeadBoardListItemParams>({
  followUpDate: date(DateFormat.DateTime),
});
